<section class="resource-with-tabs">
  <mat-card-header>
    <mat-card-title>
      {{ getCaughtObservable((viewConfig | async)?.DisplayName, false) | async }}
    </mat-card-title>
    @if (isBatchList) {
      <mat-card-subtitle class="batchlist-progress">
        <language
          key="ResourceWizardBatchListProgress"
          defaultValue="Object {0} of {1}"
          [args]="batchListProgressArgs"
        ></language>
        @if (batchListLabel) {
          <span class="batchlist-label"
            >: {{ getCaughtObservable(batchListLabel, false) | async }}</span
          >
        }
      </mat-card-subtitle>
    }
    <nav class="header-actionbar">
      @if (showWizard) {
        @if (stepperComponent?.steps.length > 1) {
          <button
            mat-raised-button
            (click)="stepperComponent.previous()"
            [disabled]="stepperComponent.selectedIndex === 0"
          >
            <div class="flex-vertical-center">
              <mat-icon>navigate_before</mat-icon>
              <language
                key="ResourceWizardGoToPrevious"
                defaultValue="Back"
                [hidden]="smallView"
              ></language>
            </div>
          </button>
          <button
            mat-raised-button
            (click)="goToNextStep()"
            [disabled]="stepperComponent.selectedIndex >= stepperComponent.steps.length - 1"
          >
            <div class="flex-vertical-center">
              <language
                key="ResourceWizardGoToNext"
                defaultValue="Next"
                [hidden]="smallView"
              ></language>
              <mat-icon>navigate_next</mat-icon>
            </div>
          </button>
        }
        @if (isBatchList) {
          <button mat-raised-button (click)="skip()" [disabled]="loading || waitSpinner">
            <div class="flex-vertical-center">
              <language
                key="ResourceWizardSkip"
                defaultValue="Skip"
                [hidden]="smallView"
              ></language>
              <mat-icon>skip_next</mat-icon>
            </div>
          </button>
        }
        @if (
          this.wizardType !== WizardType.Approval && this.wizardType !== WizardType.ApprovalMultiple
        ) {
          <button
            matButton="filled"
            (click)="submit()"
            [disabled]="isBatchList && (loading || waitSpinner)"
          >
            <language key="ResourceWizardSubmit" defaultValue="Submit"></language>
          </button>
        }
        @if (
          this.wizardType === WizardType.Approval || this.wizardType === WizardType.ApprovalMultiple
        ) {
          <button
            matButton="filled"
            class="mat-filled-button-error-color"
            (click)="approveSubmit('reject')"
          >
            <language key="ResourceWizardReject" defaultValue="Reject"></language>
          </button>
        }
        @if (
          this.wizardType === WizardType.Approval || this.wizardType === WizardType.ApprovalMultiple
        ) {
          <button matButton="filled" (click)="approveSubmit('approve')">
            <language key="ResourceWizardApprove" defaultValue="Approve"></language>
          </button>
        }
        @if (allowTimeline | async) {
          <button mat-icon-button (click)="openTimeline($event)">
            <mat-icon>query_builder</mat-icon>
          </button>
        }
        @if (allowAdvancedDetail | async) {
          <button mat-icon-button (click)="toggleAdvancedDetail()" [class.enabled]="advancedDetail">
            <mat-icon>settings</mat-icon>
          </button>
        }
      }

      <button mat-icon-button class="close-icon" (click)="cancel()">
        <mat-icon>close</mat-icon>
      </button>
    </nav>
  </mat-card-header>
  <mat-card-content>
    <mat-card appearance="raised" class="inner-card">
      @if (showWizard) {
        <div class="resource-wizard my-container">
          @if ((getCaughtObservable((viewConfig | async)?.Details, false) | async)?.length === 0) {
            <div class="alert alert-warning" role="alert">
              <language
                key="ResourceWizardNoConfigurationError"
                defaultValue="No configuration for this wizard found."
              ></language>
            </div>
          }
          @if (loading) {
            <div class="loader">
              <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
            </div>
          }
          @if (waitSpinner) {
            <div class="wait-spinner">
              <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
            </div>
          }

          <mat-stepper
            #stepper
            (selectionChange)="stepEntered($event)"
            [orientation]="smallView ? 'vertical' : 'horizontal'"
          >
            @for (
              stepConfig of getCaughtObservable((viewConfig | async)?.Details, true) | async;
              track stepConfig
            ) {
              @if (
                (getCaughtObservable(stepConfig?.Visible, false) | async) === true &&
                (getCaughtObservable(stepConfig?.HasChilds, false) | async) === true
              ) {
                <mat-step
                  #step
                  [state]="step.hasError ? 'error' : 'number'"
                  [editable]="!step.isSelected()"
                  [completed]="false"
                  [label]="(getCaughtObservable(stepConfig?.Caption, false) | async)?.Values"
                >
                  <viewtab
                    [controls]="stepConfig?.Controls"
                    [objectType]="(viewConfig | async)?.ObjectType"
                    [editEnabled]="editEnabled"
                    [freshResource]="freshResource"
                    [objectID]="(getCaughtObservable(resource, false) | async)?.ObjectID?.Values"
                    [objectDisplayName]="
                      (getCaughtObservable(resource, false) | async)?.DisplayName?.Values
                    "
                    [resource]="resource | async"
                    (onAddView)="onAddView.emit($event)"
                    (onUpdateResource)="updateResource($event)"
                    (onUpdateLocalizedValue)="updateLocalizedValue($event)"
                    (onUpdateLocale)="updateLocale($event)"
                    (onUpdateValidity)="updateValidity()"
                    #view
                  ></viewtab>
                </mat-step>
              }
            }
            <ng-template matStepperIcon="error">
              <mat-icon>priority_high</mat-icon>
            </ng-template>
          </mat-stepper>

          @if (!loading && (noTabVisible() | async)) {
            <div class="detailErrors alert alert-warning" role="alert">
              <language
                key="ResourceWizardNoStepsVisible"
                defaultValue="This wizard has no visible steps."
              ></language>
            </div>
          }
          @if (!loading && (noDialogConf() | async)) {
            <div class="detailErrors errorWithButton">
              <div class="alert alert-warning" role="alert">
                <language
                  key="ResourceWizardNoDialogConf"
                  defaultValue="Dialog Configuration not found."
                ></language>
              </div>
              @if (allowAdvancedDetail | async) {
                <button
                  mat-icon-button
                  (click)="toggleAdvancedDetail()"
                  [class.enabled]="advancedDetail"
                >
                  <mat-icon>settings</mat-icon>
                </button>
              }
            </div>
          }
        </div>
      }
    </mat-card>
    <button
      class="btn-scroll-top"
      mat-icon-button
      (click)="scrollTop()"
      [matTooltip]="scrollTopText | async"
    >
      <mat-icon>arrow_upward</mat-icon>
    </button>
  </mat-card-content>
</section>
